import config from '../config';
import axios from 'axios';
 
export function getContactInfo() {
  return axios.get(`${config.API_BASE_URL}/contact/info`);
}

export function sendContactMessage(data) {
  return axios.post(`${config.API_BASE_URL}/website/message/send`, data);
} 